import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign "ResizeObserver loop" errors (fired by Radix Popover/Command
// measuring during wizard transitions). These are harmless but otherwise trigger
// the dev-server error overlay which intercepts clicks.
const RO_MSG = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes(RO_MSG)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
const _origError = window.console.error;
window.console.error = (...args) => {
  if (typeof args[0] === "string" && args[0].includes(RO_MSG)) return;
  _origError(...args);
};

// Root-cause fix: defer ResizeObserver callbacks to the next frame so the
// synchronous notification loop that produces the warning never occurs.
if (typeof window.ResizeObserver !== "undefined") {
  const NativeRO = window.ResizeObserver;
  window.ResizeObserver = class extends NativeRO {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
